import React, {Component} from 'react';
import {
    Dialog,
    DialogContent,
    Button,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    Avatar, InputLabel,
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {UecareDropdown} from '../../../../components';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxVip from '../../../../store/actionreducers/vip';
import {connect} from 'react-redux';
import _ from 'lodash';
import {constDataDialogs} from "../../../../constants";

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
});

const initNewVipState = {
    user: {
        avatar: {url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'},
    },
};

const initControllerState = {
    pricePlan:{id:0,name:'請選擇',annual_fee:'請選擇'}
};

class JoinClubDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {vip: initNewVipState, ...initControllerState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * no useRecordDialog , no data need to resolve
         */
        if (!this.props.joinClubDialog) return;

        /**
         * After Dialog Open
         */
        if (!prevProps.joinClubDialog || (!prevProps.joinClubDialog.props.open && this.props.joinClubDialog.props.open)) {
            if (this.props.vip && !_.isEqual(this.props.vip, prevState.vip)) {

                // 有些 groupType 在列表之外
                const propGroupType = this.props.groupTypes.find((groupType) => {
                    return groupType.label === this.props.vip.group.type.label;
                });

                this.setState({
                    vip: this.props.vip, ...initControllerState,
                    groupType: propGroupType || this.props.personGroupType
                });
            }
        }
    }

    handleDropDownChange = (name, value) => {
        this.setState({[name]: value});
    };

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.joinClubDialog});
    };

    render() {
        const {classes, joinClubDialog} = this.props;
        const {pricePlan} = this.state;
        const {refreshVips, vipChoosePlan, openLoadingMask, closeLoadingMask} = this.props;
        const plan_prop = (joinClubDialog && joinClubDialog.payload)
                            ? joinClubDialog.payload.filter((plan) => (plan.id != null))
                            : []

        if (!joinClubDialog || joinClubDialog.props.open === false) return <div/>;

        return (
            <Dialog className={classes.root} {...joinClubDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            選擇方案
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <Avatar className="w-96 h-96" alt="contact avatar" src={this.state.vip.user.avatar.url}/>
                        <Typography variant="title" color="inherit" className="pt-8">
                            {this.state.vip.user.name}
                        </Typography>
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <UecareDropdown
                        label='方案類型'
                        icon='card_giftcard'
                        name='pricePlanId'
                        id='pricePlan'
                        className={classes.formControl}
                        value={pricePlan.id}
                        options={plan_prop}
                        onChange={(event, selectedOption) => {
                            this.handleDropDownChange('pricePlan', selectedOption);
                        }}/>
                    <InputLabel style={{padding:5}}>{`年費：${pricePlan.annual_fee}`}</InputLabel>

                    <InputLabel style={{padding:5}}>{'請確認客戶已經簽約'}</InputLabel>

                </DialogContent>

                <DialogActions className="justify-between pl-16">
                    <Button
                        variant="raised"
                        color="primary"
                        onClick={async () => {
                            if (pricePlan.id === 0) {
                                alert('必須選擇一個方案才能送出');
                                return;
                            }
                            try {
                                const vipId = this.props.vip.id;
                                openLoadingMask();
                                await vipChoosePlan({vipId, pricePlan});
                                await refreshVips();
                                closeLoadingMask();
                                this.closeDataDialog();
                            } catch (e) {
                                console.warn('you got an error = ', e);
                            }

                        }}
                    >
                        確認送出
                    </Button>
                </DialogActions>

            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        refreshVips: ReduxVip.ActionCreator.refreshVips,
        vipChoosePlan: ReduxVip.ActionCreator.vipChoosePlan,
        companyVipJoinClub: ReduxVip.ActionCreator.companyVipJoinClub,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({global: {dataDialogs}, group: {groups}, company: {companies}, vip: {vip}, missionPriceType, groupType}) {
    const personGroupType = groupType.list.find((groupType) => {
        return groupType.label === 'person';
    });

    return {
        groups,
        companies,
        vip,
        joinClubDialog: dataDialogs[constDataDialogs.name.joinClubDialog],
        missionPriceTypes: missionPriceType.list,
        groupTypes: groupType.list,
        personGroupType
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(JoinClubDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/JoinClubDialog.js